module.exports = __webpack_public_path__ + "img/background.034e6a35.jpg";